import ActionLogger from "action-logger";
import MembershipHelpers from "helpers/membership-helpers";
import { isFilteredByShippingAddress } from "helpers/grid-top-filters-helpers";
import { analytics } from "rtr-constants";
import sharedActions from "actions/shared-actions";
import GridTopFiltersAddressModal from "components/source/new_taxonomy/grid-top-filters-address-modal";
import GridTopFiltersDateModal from "components/source/new_taxonomy/grid-top-filters-date-modal";
import GridTopFiltersSizeModal from "components/source/new_taxonomy/grid-top-filters-size-modal";
import GridTopFiltersZipModal from "components/source/new_taxonomy/grid-top-filters-zip-modal";
import GridAvailabilityModal from "components/source/new_taxonomy/grid-availability-modal";
const mobileFilterModalName = "filter-modal";

const loggingObjectType = analytics.OBJECT_TYPE.GRID;

const logOpenLocationFilterModal = (showShippingFilter, userData) => {
  const lens = MembershipHelpers.getUserDataLens(userData);

  ActionLogger.logAction({
    object_type: loggingObjectType,
    action: "zip_code_search",
    lens: lens,
    zip_code_populated: !showShippingFilter,
    address_populated: showShippingFilter,
  });
};

const logOpenSizeFilterModal = workingFilters => {
  ActionLogger.logAction({
    object_type: loggingObjectType,
    action: "size_search",
    size_populated: !!workingFilters?.canonicalSizes?.length,
  });
};

const logOpenDateFilterModal = (workingFilters, userData) => {
  const sizeFilters = workingFilters?.canonicalSizes ?? [];
  const lens = MembershipHelpers.getUserDataLens(userData);

  ActionLogger.logAction({
    object_type: loggingObjectType,
    action: "rezo_search",
    itemSizes: sizeFilters.join(","),
    lens: lens,
  });
};

export const openShippingFilterModal = () => {
  return function (dispatch, getState) {
    const { userData, gridView } = getState();

    const filteredByShippingAddress = isFilteredByShippingAddress(userData, gridView);
    logOpenLocationFilterModal(filteredByShippingAddress, userData);

    dispatch(sharedActions.displayModal(GridTopFiltersAddressModal.modalName));
  };
};

export const openZipFilterModal = () => {
  return function (dispatch, getState) {
    const { userData, gridView } = getState();

    const filteredByShippingAddress = isFilteredByShippingAddress(userData, gridView);
    logOpenLocationFilterModal(filteredByShippingAddress, userData);

    dispatch(sharedActions.displayModal(GridTopFiltersZipModal.modalName));
  };
};

export const openSizeFilterModal = () => {
  return function (dispatch, getState) {
    const { workingFilters } = getState();

    logOpenSizeFilterModal(workingFilters);

    dispatch(sharedActions.displayModal(GridTopFiltersSizeModal.modalName));
  };
};

export const openDateFilterModal = () => {
  return function (dispatch, getState) {
    const { userData, workingFilters } = getState();

    logOpenDateFilterModal(workingFilters, userData);

    dispatch(sharedActions.displayModal(GridTopFiltersDateModal.modalName));
  };
};

export const openGridAvailabilityModal = () => {
  return function (dispatch) {
    dispatch(sharedActions.displayModal(GridAvailabilityModal.modalName));
  };
};

export const openMobileFilterModal = () => {
  return function (dispatch) {
    dispatch(sharedActions.displayModal(mobileFilterModalName));
  };
};

export const closeModal = () => {
  return function (dispatch) {
    dispatch(sharedActions.displayModal(false));
  };
};
